import React, { useEffect, useRef } from "react";
import lottie from "lottie-web/build/player/lottie_light";
import animationData from "../assets/basketball-loader.json";

// The same jumping ball the mobile app shows while it loads
// (bc-vikings-app/assets/animations/basketball_jumping.lottie).
export default function PageLoader() {
  const container = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!container.current) return;
    const still = window.matchMedia?.("(prefers-reduced-motion: reduce)").matches ?? false;
    const animation = lottie.loadAnimation({
      container: container.current,
      renderer: "svg",
      loop: !still,
      autoplay: !still,
      animationData,
    });
    return () => animation.destroy();
  }, []);

  return (
    <div className="page-loading" role="status">
      <div ref={container} className="page-loading-animation" aria-hidden="true" />
      <span className="visually-hidden">Загрузка…</span>
    </div>
  );
}
